import * as Leo from "@adobe/leonardo-contrast-colors";
import findMatchingLuminosity from "components/ui/colors/findMatchingLuminosity";
import getLuminosities from "components/ui/colors/getLuminosities";
import round from "components/ui/round";

export default function buildColorScale(
  swatches: number,
  baseColors: Leo.CssColor[],
  distributeLightness: "polynomial" | "linear" = "linear",
  colorspace: Leo.InterpolationColorspace = "HSL",
) {
  const minLuminosity = Math.min(...getLuminosities(baseColors));
  const maxLuminosity = Math.max(...getLuminosities(baseColors));
  const delta = maxLuminosity - minLuminosity;
  const generousColorLength = distributeLightness === "polynomial" ? 100 : 10;

  const initialColorScale = Leo.createScale({
    swatches: generousColorLength,
    colorKeys: baseColors,
    colorspace,
    distributeLightness,
    smooth: false,
    fullScale: false,
    asFun: true,
  });

  const fillRange = (start: number, end: number) => {
    return Array(end - start)
      .fill(0)
      .map((_, index) => start + index);
  };

  const dataX = fillRange(0, generousColorLength).map((x) => {
    return x === 0 ? 0 : x / (generousColorLength - 1);
  });
  const newColors = findMatchingLuminosity(
    initialColorScale,
    generousColorLength,
    dataX.map((i) => round(delta * i + minLuminosity, 2)),
    false,
  );
  return Leo.createScale({
    swatches,
    colorKeys: newColors as Leo.CssColor[],
    distributeLightness,
    colorspace,
    fullScale: false,
    smooth: false,
  });
}
